export function isDateExpired(date: Date): boolean {
  // is the current date past the provided date
  return new Date() > date;

}